
export interface PhoneCore {
  countryCode: string;
  phone: string;
}

export class Phone implements PhoneCore {

  countryCode: string;
  phone: string;

  constructor(countryCode: string, phone: string) {
    this.countryCode = countryCode;
    this.phone = phone;
  }

  public toString(): string {
    if (!this.countryCode.includes('+')) {
      this.countryCode = '+' + this.countryCode;
    }
    return `${this.countryCode}-${this.phone}`;
  }

  public phoneValidation(): boolean {
    if (!this.phone || !this.countryCode) return false;
    if (this.phone.trim().length === 0 || this.countryCode.trim().length === 0) return false;
    return true;
  }
}
